import { useHistory } from 'react-router-dom'
import { DateTime } from 'luxon'
import { CourseType } from '../../types'
import { ROUTES } from '../routes'
import { getCourseLessons } from './course'

// Returns where the user should be directed when
// clicking a course from the course library.

export const useGetCourseUrl = () => {
  const history = useHistory()

  const navigateToCourse = (course: CourseType, isOwned?: boolean) => {
    if (
      !isOwned &&
      course.cartClose &&
      DateTime.fromISO(course.cartClose).diffNow('seconds').seconds < 0
    ) {
      if (course.waitlist) {
        return window.open(course.waitlist, '_blank')
      }

      return history.push(ROUTES.course.byPreview(course.slug))
    }

    if (!isOwned || !course.modules) {
      return history.push(ROUTES.course.byPreview(course.slug))
    }

    const allLessons = getCourseLessons(course)

    for (let i = 0; i < allLessons.length; i++) {
      const lesson = allLessons[i]
      const isLastLesson = i === allLessons.length - 1
      const isCompleted = lesson?.isCompleted
      const isSkipped = lesson?.isSkipped

      if (isLastLesson) {
        return history.push(ROUTES.course.byLesson(course.slug, lesson.slug))
      }

      if (!isCompleted && !isSkipped) {
        return history.push(ROUTES.course.byLesson(course.slug, lesson.slug))
      }
    }

    return ''
  }

  return { navigateToCourse }
}
